import { HttpInterceptorFn } from '@angular/common/http';
import { isBffMode } from './bff';

function readAccessToken(): string | null {
  const raw = localStorage.getItem('authState');
  if (!raw) return null;
  try {
    return (JSON.parse(raw) as { accessToken?: string }).accessToken ?? null;
  } catch {
    return null;
  }
}

export const bearerInterceptor: HttpInterceptorFn = (req, next) => {
  // BFF-режим аутентифицирует cookie-сессией на сервере — старый токен из localStorage
  // (до миграции или после отката BFF_ADMIN_ENABLED) не должен глушить cookie-релей
  const token = !isBffMode() && req.url.startsWith('/api') ? readAccessToken() : null;
  return token ? next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })) : next(req);
};
